__turbopack_context__.v({
  "imgsNum": "HeroImage-module__YNEWoW__imgsNum",
  "racBadge": "HeroImage-module__YNEWoW__racBadge",
  "wrpr": "HeroImage-module__YNEWoW__wrpr",
});
